import { VueConstructor } from "vue";
import axios, { AxiosRequestConfig, Method } from "axios";
// @ts-ignore
import config from "./Api-config";
// @ts-ignore
import NProgress from "nprogress";
// @ts-ignore
import hasha from "hasha";
// @ts-ignore
import storage from "../storage/storage";
import isReachable from "is-reachable";
import app from "@/store/app";
import Auth from "@/services/Auth";
import AnnouncementModule from "sentec-vues/modules/announcement/AnnouncementModule";
import { AnnouncementApp } from "sentec-vues/modules/announcement/enums/AnnouncementApp";
import qs from "query-string";

export interface IHttp {
  postv2: (param: ApiCallParameter) => Promise<any>,
  get: (url: string, params?: any, ignoreError?: boolean, headers?: any, runtimeSize?: ApiRuntimeSize, skipCancellation?: boolean, overrideBaseUrl?: string) => Promise<any>,
  post: (url: string, data?: any, ignoreError?: boolean, headers?: any, runtimeSize?: ApiRuntimeSize, overrideBaseUrl?: string) => Promise<any>,
  postDownload: (url: string, data?: any, ignoreError?: boolean, headers?: any, runtimeSize?: ApiRuntimeSize, method?: Method, absolutePath?: boolean) => Promise<any>,
  del: (url: string, data?: any, ignoreError?: boolean, headers?: any, runtimeSize?: ApiRuntimeSize) => Promise<any>,
  put: (url: string, data?: any, ignoreError?: boolean, headers?: any, runtimeSize?: ApiRuntimeSize) => Promise<any>,
  isOnline: () => Promise<boolean>,
  hotRead(enable: boolean),
  delay: (ms: number) => Promise<boolean>,
}

declare module "vue/types/vue" {
  interface Vue {
    $http: IHttp;
  }
}

async function stringHash(value: string) {
  return hasha.async(value, { algorithm: "sha1" });
}
const announcementModule = new AnnouncementModule();
let fromWriteServer = false;
const instance = axios.create({
  baseURL: config.BASE_API_URL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
  },
});
const instanceDownloader = axios.create({
  baseURL: config.BASE_API_URL,
  withCredentials: false,
  responseType: "blob",
  headers: {
    Accept: "application/json",
  }
});
const ignoreInstance = axios.create({
  baseURL: config.BASE_API_URL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
  },
});

// before a request is made start the nprogress
instance.interceptors.request.use(async (c) => {
  NProgress.start();
  c.headers = c.headers || {};
  c.headers["token"] = await storage.getItem(config.STORAGE_KEYS.TOKEN);
  const query = qs.parse(location.search) as any;
  c.headers["sentec-app"] = `finance${query.hotelId ? "-" + query.hotelId : ""}`;
  c.headers["sentec-announcement"] = AnnouncementApp.FINANCE;
  c.params = {
    ...c.params,
    origin: location.origin,
  };
  delete c.headers["key"];
  return c;
});
// before a response is returned stop nprogress
instance.interceptors.response.use(
    async (response) => {
  const writeMethods = ["post", "put", "delete"];
  if (writeMethods.indexOf((response.config.method || "").toLocaleLowerCase()) > -1) {
    fromWriteServer = true;
    setTimeout(() => {
      fromWriteServer = false;
    }, 5000);
  }
  NProgress.done();
  const config = response.config;
  const maxAge = config.headers["max-age"];
  const key = config.headers["key"];

  if (maxAge > 0) {
    let data = "";
    if (config.data) {
      data = config.data;
    }
    const rawKey = `${config.url}${config.method}${data}`;
    const hashKey = await stringHash(rawKey);
    await storage.setItem(hashKey, response.data);
  }
  if (key != "" && key != null) {
    await storage.setItem(key, response.data);
  }
  announcementModule.CheckIfServerMaintenance(response);
  return response;
},
    async (error) => {
    NProgress.done();
    // check response header for new announcement
    announcementModule.CheckIfServerMaintenance(error.response);
    let message = "";
    if (error.response) {
      const apiResponse = error.response.data;
      app.state.info.textColor = "#E81123";
      app.state.info.icon = "fas fa-exclamation-circle";
      if (error.response.status == 429) {
        message = "Too many Requests";
      } else if (error.response.status == 503) {
        message = "Service unavailable";
      } else if (error.response.status >= 400 && error.response.status <= 599) {
        message = typeof apiResponse.Message != "undefined" ? apiResponse.Message : (message != "" ? message : "Something went wrong");
        message = message.replaceAll("\n", "<br>");
      }
      app.state.info.body = message;
      app.state.info.visible = true;
      // Catch error 403, and force logout
      if (error.response.status == 401) {
        Auth.SignOut().then(() => {
          window.location.reload();
        });
      }
    }
    if (message.indexOf("maintenance") > -1) {
      error.response.data.Data = [];
      return Promise.resolve(error);
    }

    return await Promise.reject(error);
}
);

// before a request is made start the nprogress
instanceDownloader.interceptors.request.use(async (c) => {
  NProgress.start();
  c.headers = c.headers || {};
  c.headers["token"] = await storage.getItem(config.STORAGE_KEYS.TOKEN);
  const query = qs.parse(location.search) as any;
  c.headers["sentec-app"] = `finance${query.hotelId ? "-" + query.hotelId : ""}`;
  c.headers["sentec-announcement"] = AnnouncementApp.FINANCE;
  c.params = {
    ...c.params,
    origin: location.origin,
  };
  delete c.headers["key"];
  return c;
});
// before a response is returned stop nprogress
instanceDownloader.interceptors.response.use(
    async (response) => {
  const writeMethods = ["post", "put", "delete"];
  if (writeMethods.indexOf((response.config.method || "").toLocaleLowerCase()) > -1) {
    fromWriteServer = true;
    setTimeout(() => {
      fromWriteServer = false;
    }, 5000);
  }
  NProgress.done();
  const config = response.config;
  const maxAge = config.headers["max-age"];
  const key = config.headers["key"];

  if (maxAge > 0) {
    let data = "";
    if (config.data) {
      data = config.data;
    }
    const rawKey = `${config.url}${config.method}${data}`;
    const hashKey = await stringHash(rawKey);
    await storage.setItem(hashKey, response.data);
  }
  if (key != "" && key != null) {
    await storage.setItem(key, response.data);
  }
  announcementModule.CheckIfServerMaintenance(response);
  return response;
},
    async (error) => {
      NProgress.done();
      // check response header for new announcement
      announcementModule.CheckIfServerMaintenance(error.response);
      let message = "";
      if (error.response) {
        const apiResponse = error.response.data;
        app.state.info.textColor = "#E81123";
        app.state.info.icon = "fas fa-exclamation-circle";
        if (error.response.status == 429) {
          message = "Too many Request";
        } else if (error.response.status == 503) {
          message = "Service unavailable";
        } else if (error.response.status >= 400 && error.response.status <= 599) {
          message = typeof apiResponse.Message != "undefined" ? apiResponse.Message : (message != "" ? message : "Something went wrong");
          message = message.replaceAll("\n", "<br>");
        }
        app.state.info.body = message;
        app.state.info.visible = true;
        // Catch error 403, and force logout
        if (error.response.status == 401) {
          Auth.SignOut().then(() => {
            window.location.reload();
          });
        }
      }
      if (message.indexOf("maintenance") > -1) {
        error.response.data.Data = [];
        return Promise.resolve(error);
      }

      return await Promise.reject(error);
}
);

// before a request is made start the nprogress
ignoreInstance.interceptors.request.use(async (c) => {
  NProgress.start();
  c.headers = c.headers || {};
  c.headers["token"] = await storage.getItem(config.STORAGE_KEYS.TOKEN);
  const query = qs.parse(location.search) as any;
  c.headers["sentec-app"] = `finance${query.hotelId ? "-" + query.hotelId : ""}`;
  c.headers["sentec-announcement"] = AnnouncementApp.FINANCE;
  c.params = {
    ...c.params,
    origin: location.origin,
  };
  delete c.headers["key"];
  return c;
});
// before a response is returned stop nprogress
ignoreInstance.interceptors.response.use(
    async (response) => {
  const writeMethods = ["post", "put", "delete"];
  if (writeMethods.indexOf((response.config.method || "").toLocaleLowerCase()) > -1) {
    fromWriteServer = true;
    setTimeout(() => {
      fromWriteServer = false;
    }, 5000);
  }
  NProgress.done();
  const config = response.config;
  const maxAge = config.headers["max-age"];
  const key = config.headers["key"];

  if (maxAge > 0) {
    let data = "";
    if (config.data) {
      data = config.data;
    }
    const rawKey = `${config.url}${config.method}${data}`;
    const hashKey = await stringHash(rawKey);
    await storage.setItem(hashKey, response.data);
  }
  if (key != "" && key != null) {
    await storage.setItem(key, response.data);
  }
  announcementModule.CheckIfServerMaintenance(response);
  return response;
},
    async (error) => {
      NProgress.done();
      // check response header for new announcement
      announcementModule.CheckIfServerMaintenance(error.response);
      const message = "";
      if (error.response) {
        let message = error.response.data;
        if (
            error.response.status == 500 ||
            error.response.status == 400) {
          message = message.Message;
        }
        return await Promise.reject({ message: message });
      }
      if (message.indexOf("maintenance") > -1) {
        error.response.data.Data = [];
        return Promise.resolve(error);
      }
      return await Promise.reject(error);
});

export class ApiRuntimeSize {
  static Small = "sm";
  static Medium = "md";
  static Large = "lg";
}
export class ApiCallParameter {
  url: string;
  requestId?: string;
  data?: any;
  ignoreError: boolean;
  backgroundProcess: boolean;
  usePolling: boolean;
  maxAgeInSecond: number;
  contentType: string;
  runtimeSize: ApiRuntimeSize;
  externalPolling: boolean;
  constructor(url, payload) {
    this.url = url;
    this.data = payload;
    this.ignoreError = false;
    this.backgroundProcess = false;
    this.usePolling = false;
    this.maxAgeInSecond = 0;
    this.contentType = "application/json";
    this.runtimeSize = ApiRuntimeSize.Small;
    this.externalPolling = false;
  }
  setRequestId(requestId) {
    this.requestId = requestId;
    return this;
  }
  setPayload(payload) {
    this.data = payload;
    return this;
  }
  setIgnoreError() {
    this.ignoreError = true;
    return this;
  }
  setBackgroundProcess(requestId: string) {
    this.requestId = requestId;
    this.backgroundProcess = true;
    return this;
  }
  setUsePolling() {
    this.usePolling = true;
    return this;
  }
  setMaxAge(maxAge: number) {
    this.maxAgeInSecond = maxAge;
    return this;
  }
  setContentType(contentType: string) {
    this.contentType = contentType;
    return this;
  }
  setRuntimeSize(size: ApiRuntimeSize) {
    this.runtimeSize = size;
    return this;
  }
  setExternalPolling(polling) {
    this.externalPolling = polling;
    return this;
  }
}

export class checkPollingStatus {
  completed = false;
  counter = 3;
  async start(requestId: string, runtimeSize: ApiRuntimeSize, url: string): Promise<any> {
    this.completed = false;
    this.counter = 3;
    await Api.delay(2000);
    while (!this.completed) {
      try {
        const checkCache = await Api.get(`/cachev2?key=${requestId}`
          , undefined, true);
        if (checkCache.status == 200) {
          if (checkCache.data === "") {
            if (this.counter == 0) {
              break;
            } else this.counter--;
          } else {
            if (checkCache.data !== "0" && !checkCache.data.includes(`/${runtimeSize}${url}`)) {
              if (Api.isString(checkCache.data))
                checkCache.data = JSON.parse(checkCache.data);
              if (checkCache.data.Data !== "0") {
                this.completed = true;
                if (checkCache.data.Success)
                  return await Promise.resolve(checkCache);
                else
                  return await Promise.reject({ message: checkCache.data.Message });
              }
            }
          }
        }
      } catch (error) {
        return await Promise.reject(error);
      }
      if (!this.completed) await Api.delay(2000);
    }
  }

  stop() {
    this.completed = true;
  }
}

export const Api = {
  socket: {} as any,
  isLocal: process.env.VUE_APP_LOCAL_MODE === "true",
  abortControllers: {} as Record<string, AbortController>,
  hotRead(enable: boolean) {
    fromWriteServer = enable;
    setTimeout(() => {
      fromWriteServer = false;
    }, 1000);
  },
  async isOnline(): Promise<boolean> {
    return true;
    return await isReachable(config.IS_ONLINE_URL!);
  },

  async postv2(param: ApiCallParameter): Promise<any> {
    const online = await this.isOnline();
    if (!online) {
      const cacheKey = "pending_POST";
      const cacheData = {
        Status: false,
        Message: "Offline"
      };
      const item = {
        url: param.url,
        data: param.data,
        timestamp: Math.floor(Date.now() / 1000),
        retryCount: 0,
        success: false,
        message: ""
      };
      const items: any = await storage.getItem(cacheKey) || [];
      items.push(item);
      await storage.setItem(cacheKey, items);
      return await Promise.resolve({
        data: cacheData
      });
    }
    const headers: Record<string, string> = {};
    headers["max-age"] = String(param.maxAgeInSecond);
    headers["Content-Type"] = param.contentType;
    if (param.data instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }
    if (param.requestId !== null && param.requestId !== undefined) {
      headers["Sentec-Request-Id"] = param.requestId;
    }
    if (this.isLocal || !(param.backgroundProcess && param.requestId !== null)) {
      param.url = `/${param.runtimeSize}${param.url}`;
      console.log(`direct api call for ${param.url} (local:${this.isLocal})`);
      return param.ignoreError ? ignoreInstance({
        url: param.url,
        method: "POST",
        headers,
        data: param.data,
      }) : instance({
        url: param.url,
        method: "POST",
        headers,
        data: param.data,
      });
    }
    else {
      //do the long process. wait here and process the response afterward.
      console.log(`background api call for ${param.url}`);
      NProgress.start();
      const requestId = param.requestId || "";
      try {
        const result = await ignoreInstance({
          url: `/${param.runtimeSize}/longrequest${param.url}`,
          method: "POST",
          headers,
          data: param.data,
        });
        console.log(`checkingresponse ${JSON.stringify(result)}`);
        if (param.externalPolling) {
          Promise.resolve();
          return;
        }
        if (result.status === 200) {
          if (!param.usePolling) {
            const that = this;
            this.socket.Subscribe(requestId, (e) => {
              that.processResponse(requestId, e);
            });
            //check for result on the collection for every 100 ms
            while (!this.longRequestList[requestId]) {
              console.log("waiting");
              await this.delay(500);
            }
            const data = this.longRequestList[requestId];
            delete this.longRequestList[requestId];
            //return await Promise.resolve(data);
          }
          let completed = false;
          let counter = 3;
          await this.delay(2000);
          while (!completed) {
            try {
              const checkCache = await this.get(`/cachev2?key=${requestId}`
                , undefined, true);
              console.log(`checkingresponse ${JSON.stringify(checkCache)}`);
              if (checkCache.status == 200) {
                if (checkCache.data === "") {
                  if (counter == 0) {
                    break;
                  } else counter--;
                } else {
                  if (checkCache.data !== "0" && !checkCache.data.includes(`/${param.runtimeSize}${param.url}`)) {
                    if (this.isString(checkCache.data))
                      checkCache.data = JSON.parse(checkCache.data);
                    if (checkCache.data.Data !== "0") {
                      completed = true;
                      if (checkCache.data.Success)
                        return await Promise.resolve(checkCache);
                      else
                        return await Promise.reject({ message: checkCache.data.Message });
                    }
                  }
                }
              }
            } catch (error) {
              // Handle errors
              NProgress.done();
              return await Promise.reject(error);
            }
            if (!completed) await this.delay(2000);
          }
        }
        NProgress.done();
        return Promise.reject(result);
      } catch (error) {
        NProgress.done();
        // Handle errors
        return await Promise.reject(error);
      }
    }
  }, isString(x) {
    return Object.prototype.toString.call(x) === "[object String]";
  },
  delay(ms: number): Promise<any> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },
  longRequestList: new Object(),
  processResponse(requestId, res) {
    console.log("processResponse ", requestId);
    // console.log(JSON.stringify(res));
    if (res.event === requestId) {
      this.longRequestList[requestId] = res;
      this.socket.Unsubscribe(requestId);
    }
  },
  async post(url: string, data?: any, ignoreError?: boolean, header?: any, runtimeSize?: ApiRuntimeSize, overrideBaseUrl?: string): Promise<any> {
    if (runtimeSize == null) {
      runtimeSize = ApiRuntimeSize.Small;
    }
    if (overrideBaseUrl) {
      url = `${overrideBaseUrl}${runtimeSize}${url}`;
      const query = qs.parse(location.search) as any;
      url = url?.replaceAll("{hotelId}", query.hotelId);
    } else {
      url = `/${runtimeSize}${url}`;
    }
    const online = await this.isOnline();
    if (!online) {
      const cacheKey = "pending_POST";
      const cacheData = {
        Status: false,
        Message: "Offline"
      };
      const item = {
        url,
        data,
        timestamp: Math.floor(Date.now() / 1000),
        retryCount: 0,
        success: false,
        message: ""
      };

      const items: any = await storage.getItem(cacheKey) || [];
      items.push(item);
      await storage.setItem(cacheKey, items);
      return await Promise.resolve({
        data: cacheData
      }
      );
    }
    let contentType = "application/json";
    if (header?.contentType) {
      contentType = header.contentType;
    } else if (data instanceof FormData) {
      contentType = "multipart/form-data";
    }

    const headers: Record<string, string> = {
      "max-age": header?.maxAgeInSecond || 0,
      "Content-Type": contentType,
      "Sentec-Request-Id": header?.requestId || ""
    };
    return ignoreError ? ignoreInstance({
      url,
      method: "POST",
      headers,
      data,
    }) : instance({
      url,
      method: "POST",
      headers,
      data,
    });
  },
  async postDownload(url: string, data?: any, ignoreError?: boolean, header?: any, runtimeSize?: ApiRuntimeSize, method: Method | undefined = "POST", absolutePath = false): Promise<any> {
    if (runtimeSize == null) {
      runtimeSize = ApiRuntimeSize.Small;
    }
    if (!absolutePath) {
      url = `/${runtimeSize}${url}`;
    }
    const online = await this.isOnline();
    if (!online) {
      const cacheKey = "pending_POST";
      const cacheData = {
        Status: false,
        Message: "Offline"
      };
      const item = {
        url,
        data,
        timestamp: Math.floor(Date.now() / 1000),
        retryCount: 0,
        success: false,
        message: ""
      };

      const items: any = await storage.getItem(cacheKey) || [];
      items.push(item);
      await storage.setItem(cacheKey, items);
      return await Promise.resolve({
        data: cacheData
      }
      );
    }
    let contentType = "application/json";
    if (header?.contentType) {
      contentType = header.contentType;
    } else if (data instanceof FormData) {
      contentType = "multipart/form-data";
    }
  
    const headers: Record<string, string> = {
      "max-age": header?.maxAgeInSecond || 0,
      "Content-Type": contentType,
      "Sentec-Request-Id": header?.requestId || ""
    };
    const commonInstance: unknown = {
      url,
      method,
      headers,
      data,
    };
    const axiosInstance = commonInstance as AxiosRequestConfig;
    if (absolutePath) {
      axiosInstance.baseURL = "";
    }
    return ignoreError ? ignoreInstance(axiosInstance) : instanceDownloader(axiosInstance);
  },
  async del(url: string, data?: any, ignoreError?: boolean, header?: any, runtimeSize?: ApiRuntimeSize): Promise<any> {
    const online = await this.isOnline();
    if (runtimeSize == null) {
      runtimeSize = ApiRuntimeSize.Small;
    }
    url = `/${runtimeSize}${url}`;
    if ((header?.maxAgeInSecond || 3600) > 0 && !online) {
      const rawKey = `${url}del${JSON.stringify(data)}`;
      const hashKey = await stringHash(rawKey);
      const cacheData = await storage.getItem(hashKey);
      return Promise.resolve({
        data: cacheData
      }
      );
    }
    const headers: Record<string, string> = {
      "max-age": header?.maxAgeInSecond || 0,
      "Content-Type": header?.contentType || "application/json",
      "Sentec-Request-Id": header?.requestId || ""
    };
    return ignoreError ? ignoreInstance({
      url,
      method: "DELETE",
      headers,
      data,
    }) : instance({
      url,
      method: "DELETE",
      headers,
      data,
    });
  },
  async put(url: string, data?: any, ignoreError?: boolean, maxAgeInSecond = 0, runtimeSize?: ApiRuntimeSize): Promise<any> {
    const online = await this.isOnline();
    if (runtimeSize == null) {
      runtimeSize = ApiRuntimeSize.Small;
    }
    url = `/${runtimeSize}${url}`;
    if (!online) {
      const cacheKey = "pending_PUT";
      const cacheData = {
        Status: false,
        Message: "Offline",
      };

      const item = {
        url,
        data,
        timestamp: Math.floor(Date.now() / 1000),
        retryCount: 0,
        success: false,
        message: ""
      };

      const items: any = await storage.getItem(cacheKey) || [];
      items.push(item);
      await storage.setItem(cacheKey, items);
      return Promise.resolve({
        data: cacheData
      }
      );
    }
    const headers: Record<string, string> = {
      "max-age": String(maxAgeInSecond)
    };
    const config = {
      headers
    };
    return ignoreError ? ignoreInstance.put(url, data, config) : instance.put(url, data, config);
  },
  async get(
    url: string,
    params?: any,
    ignoreError?: boolean,
    header?: any,
    runtimeSize?: ApiRuntimeSize,
    skipCancellation?: boolean,
    overrideBaseUrl?: string
  ): Promise<any> {
    if (runtimeSize == null) {
      runtimeSize = ApiRuntimeSize.Small;
    }
    url = `${overrideBaseUrl ? overrideBaseUrl : ""}/${runtimeSize}${url}`;
    const online = await this.isOnline();
    if (!online) {
      const rawKey = `${url}get`;
      const hashKey = await stringHash(rawKey);
      const cacheData = await storage.getItem(hashKey);
      return Promise.resolve({
        data: cacheData,
      }
      );
    }
    const basePath = url.split("?")[0];
    const headers: Record<string, string> = {
      "max-age": header?.maxAgeInSecond || 0,
      "Content-Type": header?.contentType || "application/json",
      "Sentec-Request-Id": header?.requestId || ""
    };
    if (fromWriteServer) {
      if (params == null) {
        params = {};
      }
      params["from-write-server"] = 1;
    }
    const config: AxiosRequestConfig = {
      url,
      method: "GET",
      params,
      headers
    };
    if (skipCancellation !== true) {
      const newAbortController = new AbortController();
      const prevAbortController = this.abortControllers[basePath];
      if (prevAbortController) {
        prevAbortController.abort();
      }
      config.signal = newAbortController.signal;
      this.abortControllers[basePath] = newAbortController;
    }
    return ignoreError ? ignoreInstance(config) : instance(config);
  },
};


export default function AxiosPlugin(Vue: VueConstructor): void {
  Api.socket = Vue.prototype.$socket;
  Vue.prototype.$http = Api;
}
